<!-- Senza questo pixel di padding compare una scrollbar verticale nella sidenav. Perchè? -->
<div class="container" [ngClass]="{'horizontal': !mobile}" style="padding: 1px;">
    <div class="wrapper" [ngStyle]="{'margin': settings.spacing}" *ngFor="let option of options">
        <div class="option" 
             style="padding: 12px;"
            [ngStyle]="{
                'border-top': '2px solid',
                'border-bottom': '2px solid',
                'border-left': settings.mode=='bordered'?'2px solid':null,
                'border-right': settings.mode=='bordered'?'2px solid':null,
                'border-radius': settings.mode=='bordered'?'6px':'none',
                'color': routingDataService.selectedMenuNodeId==option.id ? settings.selectedMenuItemStyle.fontColor
                        : hoverId==option.id ? settings.hoverMenuItemStyle.fontColor
                        : settings.menuItemStyle.fontColor,
                'font-size': settings.menuItemStyle.fontSize,
                'font-weight': settings.menuItemStyle.fontWeight,
                'border-top-color': (routingDataService.selectedMenuNodeId==option.id && settings.mode=='bordered')? settings.selectedMenuItemStyle.borderColor
                                    : (hoverId==option.id && settings.mode=='bordered')? settings.hoverMenuItemStyle.borderColor
                                    : settings.mode=='bordered'? settings.menuItemStyle.borderColor
                                    : (routingDataService.selectedMenuNodeId==option.id && settings.mode=='underlined')? 'transparent'
                                    : (hoverId==option.id && settings.mode=='underlined')? 'transparent'
                                    : settings.mode=='underlined'? 'transparent'
                                    : 'none',
                'border-left-color': (routingDataService.selectedMenuNodeId==option.id && settings.mode=='bordered')? settings.selectedMenuItemStyle.borderColor
                                : (hoverId==option.id && settings.mode=='bordered')? settings.hoverMenuItemStyle.borderColor
                                : settings.mode=='bordered'? settings.menuItemStyle.borderColor
                                : 'none',
                'border-right-color': (routingDataService.selectedMenuNodeId==option.id && settings.mode=='bordered')? settings.selectedMenuItemStyle.borderColor
                                : (hoverId==option.id && settings.mode=='bordered')? settings.hoverMenuItemStyle.borderColor
                                : settings.mode=='bordered'? settings.menuItemStyle.borderColor
                                : 'none',
                'border-bottom-color': (routingDataService.selectedMenuNodeId==option.id && settings.mode=='bordered')? settings.selectedMenuItemStyle.borderColor
                                       : (hoverId==option.id && settings.mode=='bordered')? settings.hoverMenuItemStyle.borderColor
                                       : settings.mode=='bordered'? settings.menuItemStyle.borderColor
                                       : (routingDataService.selectedMenuNodeId==option.id && settings.mode=='underlined')? settings.selectedMenuItemStyle.underlineColor
                                       : (hoverId==option.id && settings.mode=='underlined')? settings.hoverMenuItemStyle.underlineColor
                                       : settings.mode=='underlined'? settings.menuItemStyle.underlineColor
                                       : 'none',
                'background-color': routingDataService.selectedMenuNodeId==option.id ? settings.selectedMenuItemStyle.bgColor 
                                    : hoverId==option.id ? settings.hoverMenuItemStyle.bgColor
                                    : settings.menuItemStyle.bgColor
            }"
            [class.selected]="routingDataService.selectedMenuNodeId==option.id"
            (click)="select(option.id)"
            (mouseover)="hover(option.id)"
            (mouseleave)="unhover()">
            {{option.label | translate}}
        </div>
    </div>
</div>
